import { addDays } from 'date-fns';
import { useSecondRecurringSessionCalendar } from 'domains/calendars/signup/useSecondRecurringSessionCalendar';
import { useSignupDirectCtx } from 'domains/signupDirect/context';
import { getFilteringAreasByConcernKeys } from 'domains/signupDirect/misc/communicationConcerns';
import { useSplitEvaluationCtx } from '../SplitEvaluationsScheduleSection';
import { EvaluationDuration } from 'domains/calendars/types';
import { EvaluationCalendarSummary } from 'domains/calendars/v3/useEvaluationCalendarSummary';

export const useSignupSecondSplitCalendarData = () => {
  const { firstTimeSlot } = useSplitEvaluationCtx();
  const { filters } = useSignupDirectCtx();

  if (!firstTimeSlot) throw new Error('Expected first time slot to be set');
  if (!filters) throw new Error('Expected filters to be set');

  const { paymentMethod, stateCode } = filters;

  const isInsuranceAndInNetwork =
    paymentMethod.type === 'insurance' && paymentMethod.insuranceData.networkStatus === 'In-network';

  const fromDate = addDays(firstTimeSlot.time, 1);

  const query = useSecondRecurringSessionCalendar({
    firstSession: firstTimeSlot.time,
    fromDate,
    toDate: addDays(fromDate, 7),

    detectedAreas: getFilteringAreasByConcernKeys(filters.clinicalConcernKeys, filters.therapyTarget),
    insuranceName: isInsuranceAndInNetwork ? paymentMethod.insuranceData.insuranceName : undefined,
    state: stateCode,
    duration: EvaluationDuration.Split,
  });

  if (query.data) {
    return {
      ...query,
      data: filterDataByTherapistID(query.data, firstTimeSlot.therapistID),
    };
  }

  return query;
};

/** @todo(juan): temporal solution until we refactor the entire tree of availability hooks */
const filterDataByTherapistID = (data: EvaluationCalendarSummary, therapistID: string): EvaluationCalendarSummary => {
  const filteredSummary = data.summaryData.map(dayData => {
    const availabilityByTherapist = dayData.availabilityByTherapist.filter(
      availability => availability.therapist.therapistID === therapistID,
    );

    const timeSlotCount = availabilityByTherapist.length;

    return {
      ...dayData,
      availabilityByTherapist,
      timeSlotCount,
    };
  });

  return {
    ...data,
    totalTimeSlots: filteredSummary.reduce((acc, dayData) => acc + dayData.timeSlotCount, 0),
    summaryData: filteredSummary,
  };
};
